module.exports = __webpack_public_path__ + "static/img/8.8bf1d8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/8.jpg
// module id = iH7U
// module chunks = 4